<template>
  <tr class="slds-hint-parent">
    <td :rowspan="collapsed ? 1 : 2" :class="{'open': !collapsed}">
      <div>
        <div>
          <button class="slds-button slds-button_icon slds-button_icon-error" @click="$emit('removeOffer', { index })" v-if="editable">
            <svg class="slds-button__icon" aria-hidden="true">
              <use xlink:href="../../../../assets/symbols.svg#delete"></use>
            </svg>
          </button>
          <button class="slds-button slds-button_icon" @click="$emit('showDetails', { index })" :disabled="!offer.mmvsList.length && !offer.vinList.length">
            <svg class="slds-button__icon" aria-hidden="true">
              <use xlink:href="../../../../assets/symbols.svg#search"></use>
            </svg>
          </button>
          <button class="slds-button slds-button_icon" @click="$emit('toggleCollapse', { index })" >
            <svg class="slds-button__icon" aria-hidden="true">
              <use xlink:href="../../../../assets/symbols.svg#chevronright" v-if="collapsed"></use>
              <use xlink:href="../../../../assets/symbols.svg#chevrondown" v-else></use>
            </svg>
          </button>
        </div>
        <div class="slds-text-color_weak slds-m-top--x-small">
          <span>{{$t('campaignDesigner.contentSelectionAndTag.mvs')}}: {{offer.mmvsList ? offer.mmvsList.length : 0}}</span>
        </div>
        <div class="slds-text-color_weak">
          <span>{{$t('campaignDesigner.contentSelectionAndTag.vin')}}: </span>
          <span :class="{'slds-text-color_success': (offer.vinList && offer.vinList.length && offer.includeOrExcludeVins === 'include'), 'slds-text-color_error': (offer.vinList && offer.vinList.length && offer.includeOrExcludeVins === 'exclude')}">{{offer.vinList ? offer.vinList.length : 0}}</span>
        </div>
      </div>
    </td>
    <td>
      <div class="wrap" style="text-align: left;width: 80px">
        {{offer.offerId}} - {{offer.title}}
      </div>
    </td>
    <td>
      {{offer.startDate | formatDate($t('general.dateFormat'))}}
    </td>
    <td>
      {{offer.endDate | formatDate($t('general.dateFormat'))}}
    </td>
    <td>
      <div class="wrap" style="width: 80px">
        {{offer.masterKey}}
      </div>
    </td>
    <td>
      <div class="wrap">
        {{$t(`brands.${offer.brand}`)}}
      </div>
    </td>
    <td>
      <span class="slds-icon_container slds-icon-utility-check slds-current-color" style="margin-left: 30px">
        <svg class="slds-icon slds-icon_x-small" aria-hidden="true">
          <use xlink:href="../../../../assets/symbols.svg#steps" v-if="offer.camper == 0"></use>
          <use xlink:href="../../../../assets/symbols.svg#check" v-else-if="offer.camper == 1"></use>
          <use xlink:href="../../../../assets/symbols.svg#close" v-else></use>
        </svg>
        <span class="slds-assistive-text" >{{offer.camper > 0}}</span>
      </span>
    </td>
    <td>
      <span class="slds-icon_container slds-icon-utility-check slds-current-color">
        <svg class="slds-icon slds-icon_x-small" aria-hidden="true">
          <use xlink:href="../../../../assets/symbols.svg#check" v-if="offer.fleet > 0"></use>
          <use xlink:href="../../../../assets/symbols.svg#steps" v-else></use>
        </svg>
        <span class="slds-assistive-text">{{offer.fleet > 0}}</span>
      </span>
    </td>
    <td v-if="offer" >
      <span v-if="offer.kmFrom === 0 && offer.kmTo === 0">-</span>
      <span v-else>{{offer.kmFrom | localizedNumber($store.getters['session/locale'])}}</span>
    </td>
    <td v-if="offer" >
      <span v-if="offer.kmFrom === 0 && offer.kmTo === 0">-</span>
      <span v-else>{{offer.kmTo | localizedNumber($store.getters['session/locale'])}}</span>
    </td>
    <td class="wrap" v-if="offer.timeRangeSelector === 'touchpoint'">{{$t('campaignDesigner.contentSelectionAndTag.touchPoint')}}: {{offer.range['touchpoint'].touchpointFrom}} - {{offer.range['touchpoint'].touchpointTo}}</td>
    <td class="wrap" v-else-if="offer.timeRangeSelector === 'date'">{{$t('general.from') | capitalize}} {{offer.range['date'].dateFrom | formatDate($t('general.dateFormat'))}} {{$t('general.to')}} {{offer.range['date'].dateTo | formatDate($t('general.dateFormat'))}}</td>
    <td class="wrap" v-else-if="offer.timeRangeSelector === 'age'">{{offer.range['age'].monthAge}} {{$t('general.months')}}</td>
    <td v-else>&nbsp;</td>
    <template v-if="editable">
      <td>
        <Picklist
          :options="contentPriorityOptions"
          :validation="['required']"
          labels-prefix="campaignDesigner.contentSelectionAndTag.contentPriority"
          ref="contentPriority"
          small
          v-model="contentPriority" />
      </td>
      <td>
        <Picklist
          :options="firstTagOptions"
          :validation="['required']"
          ref="tag_0"
          small
          v-if="editable"
          v-model="firstTag" />

        <Picklist
          :disabled="!firstTag || !secondTagOptions || !secondTagOptions.length"
          :options="secondTagOptions"
          :validation="['required']"
          ref="tag_1"
          small
          v-if="editable"
          v-model="secondTag" />

        <Picklist
          :disabled="!firstTag || !secondTag || !thirdTagOptions || !thirdTagOptions.length"
          :options="thirdTagOptions"
          :validation="['required']"
          ref="tag_2"
          small
          v-if="editable"
          v-model="thirdTag" />
      </td>

    </template>
    <template v-else>
      <td>
        {{$t(`campaignDesigner.contentSelectionAndTag.contentPriority.${offer.contentPriority}`)}}
      </td>
      <td style="white-space: pre-line;margin-right: 15px">
        {{"•"+firstTag.label}} 
        {{"•"+secondTag.label}}
        {{"•"+thirdTag.label}} 
        <!-- <OutputField type="array" :value="[firstTag.label, secondTag.label, thirdTag.label]" /> -->
      </td>
    </template>
  </tr>
</template>
<script>
import _ from 'lodash'
import { getTags } from './tagUtils'
import OutputField from '../../../slds/OutputField'
import Picklist from '../../../slds/Picklist'
export default {
  components: {
    OutputField,
    Picklist
  },
  props: {
    collapsed: Boolean,
    editable: Boolean,
    index: Number,
    offer: Object,
    tags: Array
  },
  data () {
    return {
      contentPriority: '',
      contentPriorityOptions: [
        'primary',
        'secondary',
        'tertiary'
      ],
      localOffer: {},
      firstTag: '',
      firstTagOptions: [],
      secondTag: '',
      secondTagOptions: [],
      thirdTag: '',
      thirdTagOptions: []
    }
  },
  mounted () {
    this.restoreTags()
  },
  methods: {
    restoreTags () {
      const { tags, contentPriority } = this.offer

      const [ tag0, tag1, tag2 ] = tags

      this.firstTagOptions = getTags(this.tags)

      if (tag0) this.secondTagOptions = getTags(this.tags, [tags[0]])
      if (tag0 && tag1) this.thirdTagOptions = getTags(this.tags, [tags[0], tags[1]])

      if (tag0) this.firstTag = tag0
      this.$nextTick(() => {
        if (tag1) this.secondTag = tag1
        this.$nextTick(() => {
          if (tag2) this.thirdTag = tag2
        })
      })

      this.contentPriority = contentPriority
    },
    updateTagsOnOffer (position, value) {
      this.$emit('tagUpdate', { index: this.index, position, value })
    },
    validate () {
      const validationResult = [
        this.$refs.contentPriority.validate(),
        this.$refs.tag_0.validate(),
        this.$refs.tag_1.disabled || this.$refs.tag_1.validate(),
        this.$refs.tag_2.disabled || this.$refs.tag_2.validate()
      ]
      return validationResult.every(v => v)
    }
  },
  watch: {
    contentPriority (contentPriority) {
      this.$emit('update-content-priority', { index: this.index, value: contentPriority })
    },
    firstTag (tag) {
      if (tag) {
        this.secondTagOptions = getTags(this.tags, [tag])
        this.thirdTagOptions = []
        this.thirdTag = ''
        this.updateTagsOnOffer(0, tag)
        this.updateTagsOnOffer(1, '')
        this.updateTagsOnOffer(2, '')
      }
    },
    secondTag (tag) {
      if (tag) {
        this.thirdTag = ''
        this.thirdTagOptions = getTags(this.tags, [this.firstTag, tag])
        this.updateTagsOnOffer(1, tag)
        this.updateTagsOnOffer(2, '')
      }
    },
    thirdTag (tag) {
      if (tag) {
        this.updateTagsOnOffer(2, tag)
      }
    },
    offer (offer) {
      this.localOffer = offer
      this.firstTag = ''
      this.secondTag = ''
      this.thirdTag = ''

      const { tags } = this.offer
      this.firstTagOptions = getTags(this.tags)

      if (tags[0]) {
        this.secondTagOptions = getTags(this.tags, [tags[0]])

        if (tags[1]) {
          this.thirdTagOptions = getTags(this.tags, [tags[0], tags[1]])
        }
      }

      if (tags[0]) {
        this.firstTag = tags[0]

        if (tags[1]) {
          this.secondTag = tags[1]

          this.$nextTick(() => {
            if (tags[2]) {
              this.thirdTag = tags[2]
            }
          })
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  .open {
    vertical-align: baseline;
  }
  .slds-text-color_weak {
    font-size: smaller;
  }
  .wrap {
    text-align: center;
    width: 7rem;
    word-break: break-word;
    white-space: pre-line;
  }

  td{
    font-size: 10px;
    
  }
</style>
